// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';
var baseUrl = '/';

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith#Polyfill
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchStr, Position) {
        // This works much better than >= because
        // it compensates for NaN:
        if (!(Position < this.length))
            Position = this.length;
        else
            Position |= 0; // round position
        return this.substr(Position - searchStr.length,
            searchStr.length) === searchStr;
    };
}

//https://stackoverflow.com/questions/36213455/add-startswith-in-ie-11
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun/*, thisArg*/) {
        'use strict';

        if (this === void 0 || this === null) {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];

                if (fun.call(thisArg, val, i, t)) {
                    res.push(val);
                }
            }
        }

        return res;
    };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

/* App Module */
var itero = angular.module('itero', ['ngRoute', 'iteroControllers', 'iteroComponents', 'iteroFilters', 'iteroServices', 'ui', 'ui.bootstrap', 'tmh.dynamicLocale', 'ngUpload', 'gettext', 'nvd3ChartDirectives', 'angularFileUpload', 'ui.sortable', 'colorpicker.module']);

var iteroComponents = angular.module('iteroComponents', []);

itero.linkVersion = '?189';

itero
    .config(['$routeProvider', '$httpProvider', 'tmhDynamicLocaleProvider', '$locationProvider', '$qProvider', function ($routeProvider, $httpProvider, tmhDynamicLocaleProvider, $locationProvider, $qProvider) {
        $qProvider.errorOnUnhandledRejections(false);

        $locationProvider.hashPrefix("");

        tmhDynamicLocaleProvider.localeLocationPattern('/scripts/i18n/angular-locale_{{locale}}.js');

        var interceptor = ['$rootScope', '$q', function (scope, $q) {
            function onRequest(config) {
                if (config.headers["Authorization"] === null) {
                    delete config.headers["Authorization"];
                }

                if (config.headers["X-SELECTED-LEGAL-ENTITY-ID"] === null) {
                    delete config.headers["X-SELECTED-LEGAL-ENTITY-ID"];
                }

                scope.recordActivity(config);
                
                return config;
            }

            function success(response) {
                return response;
            }

            function error(response) {
                var status = response.status;

                if (status === 401) {
                    $q.defer();
                    scope.username = scope.password = scope.accessToken = scope.refreshToken = null;
                    scope.clearLocalStorage();
                    $httpProvider.defaults.headers.common["Authorization"] = null;
                    window.location = "/#/login";
                } else if (status === 403) {
                    var message403 = response.data.Message || "Sorry, that doesn't work. You don't have the appropriate permission.";
                    scope.showErrorBox(message403);
                } else if (status === 405) {
                    var message405 = "Sorry, that doesn't work. This operation is not allowed.";
                    scope.showErrorBox(message405);
                } else if (status === 404 && /has been archived, and cannot be accessed$/.test(response.data.Message)) {
                    let message = response.data.Message;
                    scope.showWarningBox(message);
                } else if (status === 400 && response.data.Message === "The X-SELECTED-LEGAL-ENTITY-ID header or query parameter is required.") {
                    $q.defer();
                    $httpProvider.defaults.headers.common["X-SELECTED-LEGAL-ENTITY-ID"] = null;
                    window.location = "/#/legalentity/switch";
                } else {
                    let message = response.data.Message || response.data.error_description;
                    if (!message) {
                        message = JSON.stringify(response.data);
                    }
                    scope.showErrorBox(message);
                }
                // otherwise
                return $q.reject(response);
            }

            return {
                'request': onRequest,
                'response': success,
                'responseError': error
            };
        }];

        $httpProvider.interceptors.push(interceptor);

        $routeProvider.
            when("/admin-login/:entityId/:secret", { templateUrl: 'partials/admin-login.html' + itero.linkVersion, controller: AdminLoginController, embeddedNavigationAllowed: false }).
            when("/external-login/:entityId", { templateUrl: 'partials/external-login.html' + itero.linkVersion, controller: ExternalLoginController, embeddedNavigationAllowed: false }).
            when('/dashboard', { templateUrl: 'partials/dashboard.html' + itero.linkVersion, controller: DashboardController, embeddedNavigationAllowed: false }).
            when('/dashboard/emailhandling/:emailId', { templateUrl: 'partials/email-handling.html' + itero.linkVersion, controller: EmailHandlingController, embeddedNavigationAllowed: false }).
            when('/components/:componentId', { templateUrl: 'partials/component-edit.html' + itero.linkVersion, controller: ComponentEditController, embeddedNavigationAllowed: false }).
            when('/contracts/:contractId', { templateUrl: 'partials/contract-details.html' + itero.linkVersion, controller: ContractController, embeddedNavigationAllowed: false }).
            when('/embedded/contracts/:contractId', { templateUrl: 'partials/contract-details.html' + itero.linkVersion, controller: ContractController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/components', { templateUrl: 'partials/contract-components.html' + itero.linkVersion, controller: ContractController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/history', { templateUrl: 'partials/contract-history.html' + itero.linkVersion, controller: ContractController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/upgrade', { templateUrl: 'partials/contract-upgrade.html' + itero.linkVersion, controller: ContractUpgradeController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/upgrade/confirm', { templateUrl: 'partials/contract-confirm-upgrade.html' + itero.linkVersion, controller: ContractConfirmUpgradeController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/payment', { templateUrl: 'partials/contract-payment.html' + itero.linkVersion, controller: ContractPaymentController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/build-invoice', { templateUrl: 'partials/invoice-builder.html' + itero.linkVersion, controller: InvoiceBuilderController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/build-creditnote', { templateUrl: 'partials/invoice-builder.html' + itero.linkVersion, controller: InvoiceBuilderController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/cancel', { templateUrl: 'partials/cancel-contract.html' + itero.linkVersion, controller: ContractCancellationController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/pause', { templateUrl: 'partials/pause-contract.html' + itero.linkVersion, controller: ContractPauseController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/resume', { templateUrl: 'partials/resume-contract.html' + itero.linkVersion, controller: ContractResumeController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/end', { templateUrl: 'partials/cancel-contract.html' + itero.linkVersion, controller: ContractCancellationController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/annulate', { templateUrl: 'partials/contract-annulate.html' + itero.linkVersion, controller: ContractAnnulationController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/refund', { templateUrl: 'partials/contract-refund.html' + itero.linkVersion, controller: ContractRefundController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/move', { templateUrl: 'partials/contract-move.html' + itero.linkVersion, controller: ContractMoveController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/orders', { templateUrl: 'partials/contract-orders.html' + itero.linkVersion, controller: ContractOrdersController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/change-payment-method', { templateUrl: 'partials/contract-change-payment-method.html' + itero.linkVersion, controller: ContractChangePaymentMethodController, embeddedNavigationAllowed: true }).
            when('/contracts/:contractId/contract-write-off', { templateUrl: 'partials/contract-write-off.html' + itero.linkVersion, controller: ContractRevenueWriteOffController, embeddedNavigationAllowed: true }).
            when('/coupons/:couponId', { templateUrl: 'partials/coupon-edit.html' + itero.linkVersion, controller: CouponEditController, embeddedNavigationAllowed: false }).
            when('/customers', { templateUrl: 'partials/subscription-list.html' + itero.linkVersion, controller: SubscriptionListController, embeddedNavigationAllowed: false }).
            when('/customers/create', { templateUrl: 'partials/customer-edit.html' + itero.linkVersion, controller: CustomerEditController, embeddedNavigationAllowed: false }).
            when('/customers/:customerId/edit', { templateUrl: 'partials/customer-edit.html' + itero.linkVersion, controller: CustomerEditController, embeddedNavigationAllowed: false }).
            when('/customers/:customerId', { templateUrl: 'partials/customer-details.html' + itero.linkVersion, controller: CustomerController, embeddedNavigationAllowed: false }).
            when('/customers/:customerId/contract.create', { templateUrl: 'partials/contract-create.html' + itero.linkVersion, controller: ContractCreateController, embeddedNavigationAllowed: false }).
            when('/customers/:customerId/invoices/', { templateUrl: 'partials/invoice-full-list.html' + itero.linkVersion, controller: InvoiceController, embeddedNavigationAllowed: false }).
            when('/customers/:customerId/dunnings/', { templateUrl: 'partials/dunning-full-list.html' + itero.linkVersion, controller: DunningController, embeddedNavigationAllowed: false }).
            when('/customersExternal/:externalCustomerId', { templateUrl: 'partials/customer-details.html' + itero.linkVersion, controller: ExternalCustomerController, embeddedNavigationAllowed: false }).
            when('/discounts/:discountId', { templateUrl: 'partials/discount-edit.html' + itero.linkVersion, controller: DiscountEditController, embeddedNavigationAllowed: false }).
            when('/dunnings/:dunningId', { templateUrl: 'partials/dunning-details.html' + itero.linkVersion, controller: DunningDetailsController, embeddedNavigationAllowed: false }).
            when('/dunning-drafts/:dunningId', { templateUrl: 'partials/dunning-details.html' + itero.linkVersion, controller: DunningDetailsController, embeddedNavigationAllowed: false }).
            when('/invoice-drafts/:invoiceDraftId', { templateUrl: 'partials/invoice-draft-details.html' + itero.linkVersion, controller: InvoiceDraftDetailsController, embeddedNavigationAllowed: true }).
            when('/invoice-drafts/:invoiceDraftId/correction', { templateUrl: 'partials/invoice-correction.html' + itero.linkVersion, controller: InvoiceDraftCorrectionController, embeddedNavigationAllowed: true }).
            when('/invoices/:invoiceId', { templateUrl: 'partials/invoice-details.html' + itero.linkVersion, controller: InvoiceDetailsController, embeddedNavigationAllowed: true }).
            when('/invoices/:invoiceId/correction', { templateUrl: 'partials/invoice-correction.html' + itero.linkVersion, controller: InvoiceCorrectionController, embeddedNavigationAllowed: true }).
            when('/login', { templateUrl: 'partials/login.html' + itero.linkVersion, controller: AuthenticationController, embeddedNavigationAllowed: false }).
            when('/passwordReset', { templateUrl: 'partials/passwordReset.html' + itero.linkVersion, controller: PasswordResetController, embeddedNavigationAllowed: false }).
            when('/passwordReset/:token', { templateUrl: 'partials/passwordResetConfirmation.html' + itero.linkVersion, controller: PasswordResetConfirmationController, embeddedNavigationAllowed: false }).
            when('/passwordTooWeak/:token', { templateUrl: 'partials/passwordResetConfirmation.html' + itero.linkVersion, controller: PasswordResetConfirmationController, embeddedNavigationAllowed: false }).
            when('/passwordChangeRequired/:token', { templateUrl: 'partials/passwordChangeRequired.html' + itero.linkVersion, controller: PasswordResetConfirmationController, embeddedNavigationAllowed: false }).
            when('/passwordResetSent', { templateUrl: 'partials/passwordResetSent.html' + itero.linkVersion, embeddedNavigationAllowed: false }).
            when('/logs/payment-transactions', { templateUrl: 'partials/payment-transaction-list.html' + itero.linkVersion, controller: PaymentTransactionController, embeddedNavigationAllowed: false }).
            when('/logs/payment-transactions/search/:filter', { templateUrl: 'partials/payment-transaction-list.html' + itero.linkVersion, controller: PaymentTransactionController, embeddedNavigationAllowed: false }).
            when('/logs/payment-transactions/:paymentTransactionId', { templateUrl: 'partials/payment-transaction-details.html' + itero.linkVersion, controller: PaymentTransactionDetailController, embeddedNavigationAllowed: false }).
            when('/logs/payment-refunds', { templateUrl: 'partials/payment-refund-list.html' + itero.linkVersion, controller: PaymentRefundController, embeddedNavigationAllowed: false }).
            when('/logs/payment-refunds/:paymentRefundId', { templateUrl: 'partials/payment-refund-details.html' + itero.linkVersion, controller: PaymentRefundDetailController, embeddedNavigationAllowed: false }).
            when('/logs/emails', { templateUrl: 'partials/email-list.html' + itero.linkVersion, controller: EmailsController, embeddedNavigationAllowed: false }).
            when('/logs/emails/:emailId', { templateUrl: 'partials/email-details.html' + itero.linkVersion, controller: EmailDetailsController, embeddedNavigationAllowed: false }).
            when('/logs/emails/search/:filter', { templateUrl: 'partials/email-list.html' + itero.linkVersion, controller: EmailsController, embeddedNavigationAllowed: false }).
            when('/plangroups/create', { templateUrl: 'partials/planGroup-edit.html' + itero.linkVersion, controller: PlanGroupEditController, embeddedNavigationAllowed: false }).
            when('/plangroups', { templateUrl: 'partials/planGroup-list.html' + itero.linkVersion, controller: PlanGroupListController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/components/create', { templateUrl: 'partials/component-edit.html' + itero.linkVersion, controller: ComponentEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/edit', { templateUrl: 'partials/planGroup-edit.html' + itero.linkVersion, controller: PlanGroupEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/plans/create', { templateUrl: 'partials/plan-edit.html' + itero.linkVersion, controller: PlanEditController, embeddedNavigationAllowed: false }).
            when('/plans/:planId/edit', { templateUrl: 'partials/plan-edit.html' + itero.linkVersion, controller: PlanEditController, embeddedNavigationAllowed: false }).
            when('/plans/:planId/planvariants/create', { templateUrl: 'partials/planvariant-edit.html' + itero.linkVersion, controller: PlanVariantEditController, embeddedNavigationAllowed: false }).
            when('/planvariants/:planVariantId/edit', { templateUrl: 'partials/planvariant-edit.html' + itero.linkVersion, controller: PlanVariantEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/components/create', { templateUrl: 'partials/component-edit.html' + itero.linkVersion, controller: ComponentEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/coupons/create', { templateUrl: 'partials/coupon-edit.html' + itero.linkVersion, controller: CouponEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/discounts/create', { templateUrl: 'partials/discount-edit.html' + itero.linkVersion, controller: DiscountEditController, embeddedNavigationAllowed: false}).
            when('/products', { templateUrl: 'partials/product-list.html' + itero.linkVersion, controller: ProductController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/pricelists', { templateUrl: 'partials/priceList-list.html' + itero.linkVersion, controller: PriceListController, embeddedNavigationAllowed: false }).
            when('/pricelists/:priceListId/edit', { templateUrl: 'partials/priceList-edit.html' + itero.linkVersion, controller: PriceListEditController, embeddedNavigationAllowed: false }).
            when('/plangroups/:planGroupId/pricelists/create', { templateUrl: 'partials/priceList-edit.html' + itero.linkVersion, controller: PriceListEditController, embeddedNavigationAllowed: false }).
            //when('/settings/self-service', { templateUrl: 'partials/selfService.html', controller: SelfServiceController, embeddedNavigationAllowed: false }).
            when('/settings/self-service', { templateUrl: 'partials/settings-selfService.html' + itero.linkVersion, controller: SelfServiceSettingsController, embeddedNavigationAllowed: false }).
            when('/signup', { templateUrl: 'partials/signup.html' + itero.linkVersion, controller: SignupController, embeddedNavigationAllowed: false }).
            when('/signupcomplete', { templateUrl: 'partials/signupcomplete.html' + itero.linkVersion, controller: SignupCompleteController, embeddedNavigationAllowed: false }).
            when('/proceedSignupConfirmation', { templateUrl: 'partials/proceedSignupConfirmation.html' + itero.linkVersion, embeddedNavigationAllowed: false }).
            when('/signup/:token', { templateUrl: 'partials/accountsetup.html' + itero.linkVersion, controller: AccountSetupController, embeddedNavigationAllowed: false }).
            when('/internalsignup/:token', { templateUrl: 'partials/internalaccountsetup.html' + itero.linkVersion, controller: AccountSetupController, embeddedNavigationAllowed: false }).
            when('/settings/accountingexport', { templateUrl: 'partials/settings-accounting-export.html' + itero.linkVersion, controller: AccountingExportSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/extrafields', { templateUrl: 'partials/settings-extrafields.html' + itero.linkVersion, controller: AccountingExportExtraFieldsController, embeddedNavigationAllowed: false }).
            when('/settings/debitoraccountgenerator', { templateUrl: 'partials/settings-debitoraccountgenerator.html' + itero.linkVersion, controller: DebitorAccountGeneratorController, embeddedNavigationAllowed: false }).
            when('/settings/webhooks', { templateUrl: 'partials/settings-webhooks.html' + itero.linkVersion, controller: WebhooksSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/legal', { templateUrl: 'partials/settings-legal.html' + itero.linkVersion, controller: LegalSettingsController, embeddedNavigationAllowed: false }).
            when('/user-settings/password', { templateUrl: 'partials/user-settings/password.html' + itero.linkVersion, controller: PasswordChangeController, embeddedNavigationAllowed: false }).
            when('/user-settings/user', { templateUrl: 'partials/user-settings/user.html' + itero.linkVersion, controller: UserSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/users', { templateUrl: 'partials/account-settings/users.html' + itero.linkVersion, controller: UserListController, embeddedNavigationAllowed: false }).
            when('/account-settings/company', { templateUrl: 'partials/account-settings/company.html' + itero.linkVersion, controller: CompanySettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/legal-entity', { templateUrl: 'partials/account-settings/legal-entity-list.html' + itero.linkVersion, controller: LegalEntityListSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/legal-entity/:parentId', { templateUrl: 'partials/account-settings/legal-entity-list.html' + itero.linkVersion, controller: LegalEntityListSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/legal-entity/create/:parentId', { templateUrl: 'partials/account-settings/legal-entity-edit.html' + itero.linkVersion, controller: LegalEntityEditSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/legal-entity/update/:entityId', { templateUrl: 'partials/account-settings/legal-entity-edit.html' + itero.linkVersion, controller: LegalEntityEditSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/salesentities', { templateUrl: 'partials/account-settings/salesentities-list.html' + itero.linkVersion, controller: SalesEntityListSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/salesentities/create', { templateUrl: 'partials/account-settings/salesentities-edit.html' + itero.linkVersion, controller: SalesEntityEditSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/salesentities/:salesEntityId', { templateUrl: 'partials/account-settings/salesentities-edit.html' + itero.linkVersion, controller: SalesEntityEditSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/planandbilling', { templateUrl: 'partials/account-settings/planandbilling.html' + itero.linkVersion, controller: PlanAndBillingSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/backup', { templateUrl: 'partials/settings-backup.html' + itero.linkVersion, controller: BackupSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/rtlfaststatsreport', { templateUrl: 'partials/settings-rtl-fast-stats-report.html' + itero.linkVersion, controller: RtlFastStatsReportSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/customfields', { templateUrl: 'partials/settings-customfields.html' + itero.linkVersion, controller: CustomFieldsSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/accountdata', { templateUrl: 'partials/account-settings/account-data.html' + itero.linkVersion, controller: AccountDataSettingsController, embeddedNavigationAllowed: false }).
            when('/account-settings/security', { templateUrl: 'partials/account-settings/security.html', controller: SecuritySettingsController, embeddedNavigationAllowed: false }).
            when('/settings/taxpolicies', { templateUrl: 'partials/taxpolicy-list.html' + itero.linkVersion, controller: TaxPolicyListController, embeddedNavigationAllowed: false }).
            when('/settings/taxpolicies/create', { templateUrl: 'partials/taxpolicy-edit.html' + itero.linkVersion, controller: TaxPolicyEditController, embeddedNavigationAllowed: false }).
            when('/settings/taxpolicies/:taxPolicyId', { templateUrl: 'partials/taxpolicy-edit.html' + itero.linkVersion, controller: TaxPolicyEditController, embeddedNavigationAllowed: false }).
            when('/settings/taxdefinitions', { templateUrl: 'partials/taxdefinition-list.html' + itero.linkVersion, controller: TaxDefinitionListController }).
            when('/settings/taxdefinitions/create', { templateUrl: 'partials/taxdefinition-edit.html' + itero.linkVersion, controller: TaxDefinitionEditController }).
            when('/settings/taxdefinitions/:taxDefinitionId', { templateUrl: 'partials/taxdefinition-edit.html' + itero.linkVersion, controller: TaxDefinitionEditController }).
            when('/settings/oauth-clients', { templateUrl: 'partials/settings-oauth-clients.html' + itero.linkVersion, controller: OAuthClientsController, embeddedNavigationAllowed: false }).
            when('/settings/oauth-clients/:id', { templateUrl: 'partials/settings-oauth-client-details.html' + itero.linkVersion, controller: OAuthClientDetailsController, embeddedNavigationAllowed: false }).
            when('/settings/oauth-grants', { templateUrl: 'partials/settings-oauth-grants.html' + itero.linkVersion, controller: OAuthGrantsController, embeddedNavigationAllowed: false }).
            when('/settings/email-notifications-templates', { templateUrl: 'partials/settings-email-notifications-templates.html' + itero.linkVersion, controller: EmailNotificationsTemplatesController, embeddedNavigationAllowed: false }).
            when('/settings/email-notifications-events', { templateUrl: 'partials/settings-email-notifications-events.html' + itero.linkVersion, controller: EmailNotificationsEventsController, embeddedNavigationAllowed: false }).
            when('/settings/email-notifications-template/create', { templateUrl: 'partials/settings-email-notifications-template-edit.html' + itero.linkVersion, controller: EmailNotificationsTemplateEditController, embeddedNavigationAllowed: false }).
            when('/settings/email-notifications-template/:templateId', { templateUrl: 'partials/settings-email-notifications-template-edit.html' + itero.linkVersion, controller: EmailNotificationsTemplateEditController, embeddedNavigationAllowed: false }).
            when('/settings/documents', { templateUrl: 'partials/settings-documents.html' + itero.linkVersion, controller: GeneralSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/sequences', { templateUrl: 'partials/settings-sequence-list.html' + itero.linkVersion, controller: NumberSequenceListController, embeddedNavigationAllowed: false }).
            when('/settings/sequences/:sequenceId/edit', { templateUrl: 'partials/settings-sequence-edit.html' + itero.linkVersion, controller: NumberSequenceController, embeddedNavigationAllowed: false }).
            when('/settings/sequences.create', { templateUrl: 'partials/settings-sequence-create.html' + itero.linkVersion, controller: NumberSequenceController, embeddedNavigationAllowed: false }).
            when('/settings/payment-escalation', { templateUrl: 'partials/settings-payment-escalation-edit.html' + itero.linkVersion, controller: PaymentEscalationProcessListController, embeddedNavigationAllowed: false }).
            when('/settings/payment-escalation/create', { templateUrl: 'partials/settings-payment-escalation-edit.html' + itero.linkVersion, controller: PaymentEscalationProcessEditController, embeddedNavigationAllowed: false }).
            when('/settings/payment-escalation/:paymentEscalationProcessId', { templateUrl: 'partials/settings-payment-escalation-edit.html' + itero.linkVersion, controller: PaymentEscalationProcessEditController, embeddedNavigationAllowed: false }).
            when('/settings/payment-providers-list', { templateUrl: 'partials/payment-providers-settings/settings-paymentProviders-list.html' + itero.linkVersion, controller: PaymentProviderSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/payment-providers-general', { templateUrl: 'partials/payment-providers-settings/settings-paymentProviders-general.html' + itero.linkVersion, controller: PaymentProviderGeneralSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/payment-provider/:paymentProvider/edit', { templateUrl: 'partials/payment-providers-settings/settings-paymentProvider.html' + itero.linkVersion, controller: PaymentProviderSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/payment-provider/:paymentProvider/:paymentProviderExternalId?/edit', { templateUrl: 'partials/payment-providers-settings/settings-paymentProvider.html' + itero.linkVersion, controller: PaymentProviderSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/payment-provider/:paymentProvider/:paymentProviderExternalId?/charge-back-fees/edit', { templateUrl: 'partials/payment-providers-settings/settings-paymentProvider-chargeBackFees.html' + itero.linkVersion, controller: PaymentProviderChargeBackFeesSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/billing', { templateUrl: 'partials/settings-billing.html' + itero.linkVersion, controller: BillingSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/invoices', { templateUrl: 'partials/settings-invoices.html' + itero.linkVersion, controller: InvoiceTemplateController, embeddedNavigationAllowed: false }).
            when('/settings/invoices/email', { templateUrl: 'partials/settings-invoices-email.html' + itero.linkVersion, controller: InvoiceEmailEditController, embeddedNavigationAllowed: false }).
            when('/settings/invoices/extended', { templateUrl: 'partials/settings-invoices-extended.html' + itero.linkVersion, controller: InvoiceExtendedSettingsEditController, embeddedNavigationAllowed: false }).
            when('/settings/creditnotes', { templateUrl: 'partials/settings-creditnotes.html' + itero.linkVersion, controller: CreditNoteTemplateController, embeddedNavigationAllowed: false }).
            when('/settings/creditnotes/email', { templateUrl: 'partials/settings-creditnotes-email.html' + itero.linkVersion, controller: CreditNoteEmailEditController, embeddedNavigationAllowed: false }).
            when('/settings/sepaddprenotification/email', { templateUrl: 'partials/settings-sepaddprenotification-email.html' + itero.linkVersion, controller: SEPADDPrenotificationEmailEditController, embeddedNavigationAllowed: false }).
            when('/settings/dunnings', { templateUrl: 'partials/settings-dunnings.html' + itero.linkVersion, controller: DunningTemplateController, embeddedNavigationAllowed: false }).
            when('/settings/external-subscriptions/GoogleIap/finishauth', { templateUrl: 'partials/settings-google-iap-finish-auth.html' + itero.linkVersion, controller: GoogleIapFinishAuthController, embeddedNavigationAllowed: false }).
            when('/settings/external-subscriptions/:type/edit', { templateUrl: 'partials/settings-external-subscriptions-edit.html' + itero.linkVersion, controller: ExternalSubscriptionSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/external-subscriptions', { templateUrl: 'partials/settings-external-subscriptions-list.html' + itero.linkVersion, controller: ExternalSubscriptionSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/pdf-by-sales-entity', { templateUrl: 'partials/settings-pdf-by-sales-entity.html' + itero.linkVersion, controller: PdfSettingsBySalesEntityController, embeddedNavigationAllowed: false }).
            when('/settings/thirdparty-integration', { templateUrl: 'partials/settings-thirdparty-integrations-list.html' + itero.linkVersion, controller: ThirdPartyIntegrationController, embeddedNavigationAllowed: false }).
            when('/settings/thirdparty-integration/:thirdPartyIntegration/edit', { templateUrl: 'partials/settings-thirdparty-integrations-edit.html' + itero.linkVersion, controller: ThirdPartyIntegrationSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/thirdparty-integration-blebics/general', { templateUrl: 'partials/settings-thirdparty-integrations-blebics-general.html' + itero.linkVersion, controller: ThirdPartyIntegrationEbicsBlSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/thirdparty-integration-blebics/permissions', { templateUrl: 'partials/settings-thirdparty-integrations-blebics-permissions.html' + itero.linkVersion, controller: ThirdPartyIntegrationEbicsBlSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/attachments-list', { templateUrl: 'partials/settings-attachments-list.html' + itero.linkVersion, controller: AttachmentsSettingsController, embeddedNavigationAllowed: false }).
            when('/settings/attachments-edit', { templateUrl: 'partials/settings-attachments-edit.html' + itero.linkVersion, controller: AttachmentSettingsEditController, embeddedNavigationAllowed: false}).
            when('/settings/attachments-edit/:id', { templateUrl: 'partials/settings-attachments-edit.html' + itero.linkVersion, controller: AttachmentSettingsEditController, embeddedNavigationAllowed: false }).
            when('/settings/prepaid-card-profiles-list/:thirdPartyIntegration', { templateUrl: 'partials/settings-prepaid-card-profiles-list.html' + itero.linkVersion, controller: PrepaidCardProfilesController, embeddedNavigationAllowed: false }).
            when('/settings/prepaid-card-profiles/:profileId', { templateUrl: 'partials/settings-prepaid-card-profiles-edit.html' + itero.linkVersion, controller: PrepaidCardProfilesEditController, embeddedNavigationAllowed: false }).
            when('/settings/prepaid-card-profiles', { templateUrl: 'partials/settings-prepaid-card-profiles-edit.html' + itero.linkVersion, controller: PrepaidCardProfilesEditController, embeddedNavigationAllowed: false }).
            when('/settings/country-whitelist', { templateUrl: 'partials/settings-country-whitelist.html' + itero.linkVersion, controller: CountryWhiteListSettingsController, embeddedNavigationAllowed: false }).
            when('/simulation', { templateUrl: 'partials/simulation.html' + itero.linkVersion, controller: SimulationController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/exports', { templateUrl: 'partials/activities-accounting-export-list.html' + itero.linkVersion, controller: AccountingExportListController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/create-export', { templateUrl: 'partials/activities-accounting-export-create.html' + itero.linkVersion, controller: AccountingExportCreateController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/postings', { templateUrl: 'partials/postings.html' + itero.linkVersion, controller: PostingsController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/debitors', { templateUrl: 'partials/activities-accounting-export-debitors.html' + itero.linkVersion, controller: AccountingExportDebitorsController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/v1-files', { templateUrl: 'partials/activities-accounting-export-v1-files.html' + itero.linkVersion, controller: AccountingExportV1FilesController, embeddedNavigationAllowed: false}).
            when('/activities/accountingexport/close-month', { templateUrl: 'partials/activities-accounting-export-close-month.html' + itero.linkVersion, controller: AccountingExportCloseMonthController, embeddedNavigationAllowed: false}).
            when('/activities/reporting', { templateUrl: 'partials/activities-reporting.html' + itero.linkVersion, controller: ReportingController, embeddedNavigationAllowed: false}).
            when('/activities/reporting-files', { templateUrl: 'partials/activities-reporting-files.html' + itero.linkVersion, controller: ReportingFilesController, embeddedNavigationAllowed: false}).
            when('/activities/reconciliation', { templateUrl: 'partials/activities-account-reconciliation.html' + itero.linkVersion, controller: ReconciliationController, embeddedNavigationAllowed: false}).
            when('/activities/reconciliationAssign/:transactionId', { templateUrl: 'partials/activities-account-reconciliation-assign.html' + itero.linkVersion, controller: ReconciliationAssignController, embeddedNavigationAllowed: false}).
            when('/activities/choose', { templateUrl: 'partials/activities-choose-activity.html' + itero.linkVersion, embeddedNavigationAllowed: false}).
            when('/activities/reconciliationManualMode', { templateUrl: 'partials/activities-account-reconciliation-manualmode.html' + itero.linkVersion, controller: ReconciliationManualModeController, embeddedNavigationAllowed: false}).
            when('/activities/reconciliationImport', { templateUrl: 'partials/activities-account-reconciliation-import.html' + itero.linkVersion, controller: ReconciliationImportController, embeddedNavigationAllowed: false }).
            when('/activities/importHistory', { templateUrl: 'partials/activities-account-reconcillation-import-history.html' + itero.linkVersion, controller: ReconciliationImportHistoryController, embeddedNavigationAllowed: false }).
            when('/activities/reconciliationDownloadFromBank', { templateUrl: 'partials/activities-account-reconciliation-download-from-bank.html' + itero.linkVersion, controller: ReconciliationDownloadFromBankController, embeddedNavigationAllowed: false }).
            when('/activities/tax-correction', { templateUrl: 'partials/tax-correction.html' + itero.linkVersion, controller: TaxCorrectionController, embeddedNavigationAllowed: false }).
            when('/activities/payments-export', { templateUrl: 'partials/activities-payments-export.html' + itero.linkVersion, controller: PaymentsExportController, embeddedNavigationAllowed: false }).
            when('/activities/payments-export-files', { templateUrl: 'partials/activities-payments-export-files.html' + itero.linkVersion, controller: PaymentsExportFilesController, embeddedNavigationAllowed: false }).
            when('/activities/revenue-write-off', { templateUrl: 'partials/activities-revenue-write-off.html' + itero.linkVersion, controller: MassRevenueWriteOffController, embeddedNavigationAllowed: false }).
            when('/activities/bulk-cancel-contracts', { templateUrl: 'partials/activities-bulk-cancel-contracts.html' + itero.linkVersion, controller: BulkCancelContractsController, embeddedNavigationAllowed: false }).
            when('/activities/bulk-upgrade-contracts', { templateUrl: 'partials/activities-bulk-upgrade-contracts.html' + itero.linkVersion, controller: BulkUpgradeContractsController, embeddedNavigationAllowed: false }).
            when('/logs/orders', { templateUrl: 'partials/order-list.html' + itero.linkVersion, controller: OrdersController, embeddedNavigationAllowed: false}).
            when('/logs/orders/search/:filter', { templateUrl: 'partials/order-list.html' + itero.linkVersion, controller: OrdersController, embeddedNavigationAllowed: false}).
            when('/logs/orders/:orderId', { templateUrl: 'partials/order-details.html' + itero.linkVersion, controller: OrderDetailsController, embeddedNavigationAllowed: true}).
            when('/logs/external-subscriptions', { templateUrl: 'partials/external-subscription-list.html' + itero.linkVersion, controller: ExternalSubscriptionListController, embeddedNavigationAllowed: false}).
            when('/logs/external-subscriptions/check', { templateUrl: 'partials/external-subscription-check.html' + itero.linkVersion, controller: ExternalSubscriptionCheckController, embeddedNavigationAllowed: false}).
            when('/logs/external-subscriptions/:id/create-contract', { templateUrl: 'partials/external-subscription-create-contract.html' + itero.linkVersion, controller: ExternalSubscriptionCreateContractController, embeddedNavigationAllowed: false}).
            when('/logs/external-subscriptions/:id', { templateUrl: 'partials/external-subscription-details.html' + itero.linkVersion, controller: ExternalSubscriptionDetailController, embeddedNavigationAllowed: false }).
            when('/logs/external-subscription-requests', { templateUrl: 'partials/external-subscription-request-list.html' + itero.linkVersion, controller: ExternalSubscriptionRequestListController, embeddedNavigationAllowed: false}).
            when('/logs/external-subscription-requests/:id', { templateUrl: 'partials/external-subscription-request-details.html' + itero.linkVersion, controller: ExternalSubscriptionRequestDetailController, embeddedNavigationAllowed: false}).
            when('/logs/webhooks', { templateUrl: 'partials/webhooks-list.html' + itero.linkVersion, controller: WebhooksController, embeddedNavigationAllowed: false }).
            when('/logs/notifications/:type?', { templateUrl: 'partials/notifications.html' + itero.linkVersion, controller: NotificationsController, embeddedNavigationAllowed: false }).
            when('/logs/auditLogs', { templateUrl: 'partials/auditLogs-list.html' + itero.linkVersion, controller: AuditLogController, embeddedNavigationAllowed: false }).
            when('/logs/einvoicing', {templateUrl: 'partials/sent-e-invoices-list.html' + itero.linkVersion, controller: EInvoicingLogsController, embeddedNavigationAllowed: false}).
            when('/logs/ebics-logs', {templateUrl: 'partials/ebics-protocol-list.html' + itero.linkVersion, controller: EbicsProtocolsController, embeddedNavigationAllowed: false}).
            when('/logs/external-transaction-requests', { templateUrl: 'partials/external-transaction-request-list.html' + itero.linkVersion, controller: ExternalTransactionRequestLogController, embeddedNavigationAllowed: false }).
            when('/logs/contract-changes/:id', { templateUrl: 'partials/contract-changes/contract-change-details.html' + itero.linkVersion, controller: ContractChangeDetailsController, embeddedNavigationAllowed: true}).
            when('/simulation', { templateUrl: 'partials/simulation.html' + itero.linkVersion, controller: SimulationController, embeddedNavigationAllowed: false }).
            when('/activities/chargebackfees', { templateUrl: 'partials/activities-chargebackfee-list.html' + itero.linkVersion, controller: ChargebackFeeController, embeddedNavigationAllowed: false }).
            when('/documents/invoices-credit-notes-drafts', { templateUrl: 'partials/invoice-draft-list.html' + itero.linkVersion, controller: InvoiceDraftController, embeddedNavigationAllowed: false }).
            when('/documents/invoices-credit-notes-final', { templateUrl: 'partials/invoice-full-list.html' + itero.linkVersion, controller: InvoiceController, embeddedNavigationAllowed: false }).
            when('/documents/dunnings-drafts', { templateUrl: 'partials/dunning-full-list.html' + itero.linkVersion, controller: DunningDraftController, embeddedNavigationAllowed: false }).
            when('/documents/dunnings-final', { templateUrl: 'partials/dunning-full-list.html' + itero.linkVersion, controller: DunningController, embeddedNavigationAllowed: false }).
            when('/legalentity/switch', { templateUrl: 'partials/entity-tenant-switch.html' + itero.linkVersion, controller: EntitySwitchController, embeddedNavigationAllowed: false }).
            when('/account-settings/invite-user', { templateUrl: 'partials/user-settings/user-state.html' + itero.linkVersion, controller: UserStateController, embeddedNavigationAllowed: false }).
            when('/account-settings/users/edit/:userId', { templateUrl: 'partials/user-settings/user-state.html' + itero.linkVersion, controller: UserStateController, embeddedNavigationAllowed: false }).
            when('/logs/taxrequests', { templateUrl: 'partials/tax-requests.html' + itero.linkVersion, controller: TaxRequestsController, embeddedNavigationAllowed: false }).
            when('/external-logout', { templateUrl: 'partials/external-logout.html' + itero.linkVersion, controller: null, embeddedNavigationAllowed: false }).
            when('/external-login-callback', { templateUrl: 'partials/external-login-callback.html' + itero.linkVersion, controller: AuthenticationController, embeddedNavigationAllowed: false }).
            when('/logs/virtual-ibans-payouts', { templateUrl: 'partials/virtual-ibans-payouts.html' + itero.linkVersion, controller: VirtualIbansPayoutsController, embeddedNavigationAllowed: false }).
        otherwise({ redirectTo: '/dashboard' });
    }])
    .run([
        '$rootScope', '$location', '$http', '$uibModal', '$filter', 'gettextCatalog', 'gettext', 'tmhDynamicLocale', 'Features', '$q', 'PublicSettings', 'LegalEntity', 'UserActivityTracker',
        function ($rootScope, $location, $http, $modal, $filter, gettextCatalog, gettext, tmhDynamicLocale, Features, $q, PublicSettings, LegalEntity, UserActivityTracker) {
            $rootScope.linkVersion = itero.linkVersion;

            $rootScope.clearLocalStorage = function () {
                const LOCAL_STORAGE_PARTIAL_KEYS_TO_KEEP = [ 'preferred_interface', '-column-states' ];
                let allLocalStorageKeys = Object.keys(localStorage)
                let itemsToKeep = allLocalStorageKeys.filter(key => LOCAL_STORAGE_PARTIAL_KEYS_TO_KEEP.some(partialKey => key.includes(partialKey)));
                allLocalStorageKeys.forEach(key => {
                    if (!itemsToKeep.includes(key)) {
                        localStorage.removeItem(key);
                    }
                });
            };
            
            $rootScope.isInFuture = function (a) {
                return moment(a).diff(moment()) > 0;
            };

            $rootScope.isBeforeToday = function (a) {
                var today = new Date().setHours(0, 0, 0, 0);
                return a < today;
            };

            $rootScope.pastOrUndefined = function (a, b) {
                return b !== undefined && moment(a).diff(moment(b)) < 0;
            };

            $rootScope.isForever = function (a) {
                return moment(a).diff(moment([9999, 12, 30])) < 0;
            };

            $rootScope.dateDiff = function (a, b) {
                return moment(a).diff(moment(b));
            };

            $rootScope.addNow = function (unit, amount) {
                return moment().add(unit, amount).format();
            };

            $rootScope.now = function () {
                return moment().format();
            };

            $rootScope.today = function () {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                return now;
            };

            $rootScope.isLoading = function (name) {
                if (name != null) {
                    return ($rootScope.requests[name] && $rootScope.requests[name] > 0);
                } else {
                    return $http.pendingRequests.length > 0;
                }
            };

            $rootScope.getLanguages = function () {
                return [
                    { key: 'de', value: $filter("translate")("German") },
                    { key: 'en', value: $filter("translate")("English") },
                    { key: 'fr', value: $filter("translate")("French") },
                    { key: 'es', value: $filter("translate")("Spanish") },
                    { key: 'ru', value: $filter("translate")("Russian") },
                    { key: 'nl', value: $filter("translate")("Dutch") },
                    { key: 'da', value: $filter("translate")("Danish") },
                    { key: 'no', value: $filter("translate")("Norwegian") },
                    { key: 'sv', value: $filter("translate")("Swedish") }
                ];
            }

            $rootScope.defaultLanguage = 'de';

            $rootScope.currentLanguage = localStorage["culture"];

            $rootScope.setLang = function (locale) {
                if (locale) {
                    tmhDynamicLocale.set(locale);
                    const language = locale.substring(0, 2);
                    gettextCatalog.setCurrentLanguage(language);                   

                    $rootScope.currentLanguage = language;
                    $rootScope.$broadcast('$languageChanged');
                }
            };

            $rootScope.clampToFuture = function (date) {
                if (typeof date === "undefined" || date === null)
                    return date;
                var date0 = moment(date);
                var now = moment();
                if (date0 >= now)
                    return date;
                else
                    return now.format();
            };

            $rootScope.isActive = function (name) {
                var path = $location.url();
                // Using a substring search (indexOf != -1) doesn't work, because then 'catalogs' and 'logs' both
                // contain logs. Instead, we're checking whether the string starts with "/name"
                var result = path.indexOf(name) === 1;
                return result;
            };

            $rootScope.pathContains = function (name) {
                var path = $location.path();
                // this is the lazy-man's approach
                var result = path.indexOf(name) !== -1;
                return result;
            };

            $rootScope.pathIs = function (name) {
                var path = $location.path();
                // this is the lazy-man's approach
                var result = path === name;
                return result;
            };

            $rootScope.log = function () {
                if (console) {
                    console.log(Array.prototype.slice.call(arguments));
                }
            };

            $rootScope.requests = {};

            $rootScope.loadData = function (name, callback) {
                var deferred = $q.defer();

                var data = { name: name };

                if (name in $rootScope.requests) {
                    $rootScope.requests[name] += 1;
                } else {
                    $rootScope.requests[name] = 1;
                }

                $rootScope.$broadcast('startLoading', data);

                callback(deferred);

                function responseHandler() {
                    if (name in $rootScope.requests) {
                        $rootScope.requests[name] -= 1;
                        if ($rootScope.requests[name] <= 0) {
                            delete $rootScope.requests[name];
                            $rootScope.$broadcast('stopLoading', data);
                        }
                    } else {
                        $rootScope.$broadcast('stopLoading', data);
                    }
                }

                deferred.promise.then(responseHandler, responseHandler);
                return deferred.promise;
            };

            $rootScope.isValid = function (form) {
                if (form['$invalid']) {
                    var errors = form['$error'];
                    for (var rover in errors) {
                        var arr = errors[rover];
                        for (var innerRover = 0; innerRover < arr.length; innerRover++) {
                            if (arr[innerRover].$name != undefined && arr[innerRover].$name !== '') {
                                var element = document.getElementsByName(arr[innerRover].$name)[0];
                                element.focus();
                            }
                        }
                    }
                    return false;
                }
                return true;
            };

            $rootScope.addTo = function (base, unit, amount) {
                var tmp = moment(base).add(unit, amount);
                return tmp.format();
            };

            $rootScope.startOf = function (desc) {
                return moment().startOf(desc).format();
            };

            $rootScope.messages = [];

            $rootScope.notifySuccess = function () {
                $rootScope.notify("success", gettextCatalog.getString(gettext("Saved Successfully")));
            };

            $rootScope.notifyCustomSuccess = function (message) {
                $rootScope.notify("success", gettextCatalog.getString(gettext(message)));
            };

            $rootScope.notifyCustomError = function (message) {
                $rootScope.notify("error", gettextCatalog.getString(gettext(message)));
            };

            $rootScope.notifyValidationError = function () {
                $rootScope.notify("error", gettextCatalog.getString(gettext("Invalid data")));
            };

            $rootScope.notify = function (type, message) {
                // $rootScope.messages = [];
                $rootScope.messages.push({ type: type, message: message });
                setTimeout(function () {
                    $rootScope.$apply(function () {
                        $rootScope.messages.splice(0, 1);
                    });
                }, 3000);
            };

            $rootScope.$watch(function () { return $location.path(); }, function (newValue) {
                // If there's no access token, we don't have to wait for the 401, redirect immediately:
                var url = $location.path();

                function getQueryParams(params, url) {
                    let href = url
                    //this expression is to get the query strings
                    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i")
                    let queryString = reg.exec(href)
                    return queryString ? queryString[1] : null
                }

                if (localStorage["oauth_error"]) {
                    var message = angular.fromJson(localStorage["oauth_error"]);
                    $rootScope.showErrorBox(message.error_description);
                    localStorage.removeItem("oauth_error");
                }

                // Force a redirect to the login page, unless the user is trying to access one of the non-authenticated regions,
                // i.e. password reset, login, signup, internalsignup. Also watch out for access tokens as request parameters. That is usually
                // not required, but for some scenarios such as file downloads, this might be required
                if (localStorage["access_token"] == null) {
                    if (newValue !== '/login'
                        && newValue.indexOf('/proceedSignupConfirmation') !== 0
                        && newValue.indexOf('/passwordReset') !== 0
                        && newValue.indexOf('/signup') !== 0
                        && newValue.indexOf('/internalsignup') !== 0
                        && newValue.indexOf('/admin-login') !== 0
                        && newValue.indexOf('/external-login') !== 0
                        && url.indexOf("access_token") < 0
                        && newValue.indexOf('/passwordTooWeak') !== 0
                        && newValue.indexOf('/passwordChangeRequired') !== 0
                        && newValue.indexOf('/external-logout') !== 0
                        && newValue.indexOf('/external-login-callback') !== 0) {
                        $location.path('/login');
                        return;
                    }

                    if (localStorage["culture"]) {
                        $rootScope.setLang(localStorage["culture"]);
                    } else {
                        var language = $rootScope.defaultLanguage;
                        localStorage["culture"] = language;
                        $rootScope.setLang(language);
                        return;
                    }
                } else if ($rootScope.access_token == null && localStorage["access_token"]) {
                    // this happens on reload, copy from local storage to root scope
                    if (window.location.href.includes('language')) {
                        var language = getQueryParams("language", window.location.href);
                        localStorage["culture"] = language;
                    }

                    $rootScope.accessToken = localStorage["access_token"];
                    $rootScope.refreshToken = localStorage["refresh_token"];
                    $rootScope.setLang(localStorage["culture"]);
                    $rootScope.username = localStorage["username"];
                    $rootScope.externalUser = localStorage["external_user"] === 'true';
                    if (localStorage["chosenEntity"] && localStorage["chosenEntity"] !== "undefined") {
                        $rootScope.chosenEntity = angular.fromJson(localStorage["chosenEntity"]);
                        $http.defaults.headers.common["X-SELECTED-LEGAL-ENTITY-ID"] = $rootScope.chosenEntity.Id;
                    }
                    if (localStorage["permissions"] && localStorage["permissions"] !== "undefined") {
                        $rootScope.permissions = angular.fromJson(localStorage["permissions"]);
                        $rootScope.$broadcast('permissions-updated');
                    }

                    if (localStorage.getItem('preferred_interface') === 'new') {
                        localStorage.setItem('preferred_interface', 'old');
                    }

                    $rootScope.user = {
                        email: localStorage["email"],
                        first: localStorage["first_name"], 
                        last: localStorage["last_name"],
                        external : localStorage["external_user"] === 'true' };
                    $http.defaults.headers.common["Authorization"] = "Bearer " + localStorage["access_token"];
                    Features.load();
                    LegalEntity.load();
                }
                $rootScope.messages.length = 0;

                //try to control not accessable routes by role
                if (newValue === '/dashboard' && !$rootScope.adminOrInRole(['Operations', 'ReadOnlyOperations', 'Reports'])) {
                    $location.path($rootScope.defaultLocation());
                }
            });

            $rootScope.onlyCancel = function (title, message, cancelCallback) {
                if (!title || !message)
                    throw new Error("missing parameter");

                var modalInstance = $modal.open({
                    templateUrl: 'partials/controls/only-cancel-modal.html' + $rootScope.linkVersion,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $modalInstance) {
                        $scope.title = title;
                        $scope.message = message;
                        $scope.cancel = function () {
                            if (cancelCallback)
                                $modalInstance.close('cancel');
                            else
                                $modalInstance.dismiss('cancel');
                        };
                    }],
                    windowClass: "fade in",
                    resolve: { title: function () { return title; }, message: function () { return message; } }
                });
                modalInstance.result.then(function (result) {
                    if (cancelCallback)
                        cancelCallback();
                });
            };

            $rootScope.onlyOk = function (title, message) {
                if (!title || !message)
                    throw new Error("missing parameter");

                var modalInstance = $modal.open({
                    templateUrl: 'partials/controls/only-ok-modal.html' + $rootScope.linkVersion,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $modalInstance) {
                        $scope.title = title;
                        $scope.message = message;
                        $scope.ok = function () { $modalInstance.close('ok'); };
                    }],
                    windowClass: "fade in",
                    resolve: { title: function () { return title; }, message: function () { return message; } }
                });
                modalInstance.result.then(function (result) { });
            };

            $rootScope.yesCancel = function (title, message, yesCallback, cancelCallback) {
                if (!title || !message || !yesCallback)
                    throw new Error("missing parameter");

                var modalInstance = $modal.open({
                    templateUrl: 'partials/controls/yes-cancel-modal.html' + $rootScope.linkVersion,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $modalInstance) {
                        $scope.title = title;
                        $scope.message = message;
                        $scope.yes = function () { $modalInstance.close('yes'); };
                        $scope.cancel = function () {
                            if (cancelCallback)
                                $modalInstance.close('cancel');
                            else
                                $modalInstance.dismiss('cancel');
                        };
                    }],
                    windowClass: "fade in",
                    resolve: { title: function () { return title; }, message: function () { return message; } }
                });
                modalInstance.result.then(function (result) {
                    if (result === 'yes')
                        yesCallback();
                    else if (cancelCallback)
                        cancelCallback();
                });
            };

            $rootScope.yesNoCancel = function (title, message, yesCallback, noCallback, cancelCallback, contentTemplate, withInput) {
                if (!title || !message || !yesCallback, !noCallback)
                    throw new Error("missing parameter");
                
                var modalInstance = $modal.open({
                    templateUrl: 'partials/controls/yes-no-cancel-modal.html' + $rootScope.linkVersion,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $modalInstance) {
                        $scope.title = title;
                        $scope.message = message;
                        $scope.withInput = withInput;
                        $scope.inputText = null;
                        $scope.contentTemplate = contentTemplate;
                        $scope.yes = function () { $modalInstance.close({answer: 'yes', inputText: $scope.inputText}); };
                        $scope.no = function () { $modalInstance.close({answer: 'no'}); };
                        $scope.cancel = function () {
                            if (cancelCallback)
                                $modalInstance.close({answer: 'cancel'});
                            else
                                $modalInstance.dismiss({answer: 'cancel'});
                        };
                    }],
                    windowClass: "fade in",
                    resolve: { title: function () { return title; }, message: function () { return message; }, contentTemplate: function () { return contentTemplate; } }
                });
                modalInstance.result.then(function (result) {
                    if (result.answer === 'yes') {
                        yesCallback(result.inputText);
                    } else if (result.answer === 'no') {
                        noCallback();
                    } else if (result.answer === 'cancel') {
                        cancelCallback();
                    }
                });
            };

            $rootScope.customPopup = function (title, contentTemplate, yesCallback, noCallback, cancelCallback, variables) {
                if (!contentTemplate)
                    throw new Error("missing parameter");

                var modalInstance = $modal.open({
                    templateUrl: 'partials/controls/custom-modal.html' + $rootScope.linkVersion,
                    controller: ['$scope', '$uibModalInstance', function ($scope, $modalInstance) {
                        $scope.contentTemplate = contentTemplate;
                        $scope.title = title;
                        $scope.variables = variables;
                        $scope.yes = function () { $modalInstance.close('yes'); };
                        $scope.no = function () { $modalInstance.close('no'); };
                        $scope.cancel = function () {
                            if (cancelCallback)
                                $modalInstance.close('cancel');
                            else
                                $modalInstance.dismiss('cancel');
                        };
                    }],
                    windowClass: "fade in",
                    resolve: { contentTemplate: function () { return contentTemplate; } }
                });
                modalInstance.result.then(function (result) {
                    if (result === 'yes') {
                        if (yesCallback) {
                            yesCallback();
                        }
                    } else if (result === 'no') {
                        if (noCallback) {
                            noCallback();
                        }
                    } else if (result === 'cancel') {
                        if (cancelCallback) {
                            cancelCallback();
                        }
                    }
                });
            };

            $rootScope.showErrorBox = function (message, link) {
                if (!$rootScope.skipErrorBox) {
                    $modal.open({
                        templateUrl: 'partials/error.html' + $rootScope.linkVersion,
                        controller: ErrorController,
                        windowClass: "fade in",
                        resolve: { error: function () { return { message: message, link : link }; } }
                    });
                    $rootScope.skipErrorBox = false;
                }
            };

            $rootScope.showWarningBox = function (message, link) {
                if (!$rootScope.skipErrorBox) {
                    $modal.open({
                        templateUrl: 'partials/warning.html' + $rootScope.linkVersion,
                        controller: WarningController,
                        windowClass: "fade in",
                        resolve: { warning: function () { return { message: message, link: link }; } }
                    });
                    $rootScope.skipErrorBox = false;
                }
            };

            $rootScope.showWarningBoxWithHandle = function (message, link) {
                let modalInstance;
                if (!$rootScope.skipErrorBox) {
                    modalInstance = $modal.open({
                        templateUrl: 'partials/warning.html' + $rootScope.linkVersion,
                        controller: WarningController,
                        windowClass: "fade in",
                        resolve: { warning: function () { return { message: message, link: link }; } }
                    });
                    $rootScope.skipErrorBox = false;
                }
                return modalInstance;
            };

            $rootScope.paginator = function (fetch, options, pageSize, useSkip = false) {
                var currentPageKey = "";
                var pages = {};

                var getNextLink = function (page) {
                    if (!page || page.length <= pageSize)
                        return null;

                    return page[page.length - 1].Id;
                };

                var getPrevLink = function (oldKey) {
                    for (var key in pages) {
                        if (getNextLink(pages[key]) === oldKey) {
                            return key;
                        }
                    }
                    return null;
                };

                // currently has quadratic complexity, since getPrevLink has linear complexity
                var getPageIndex = function (pageKey) {
                    var pageIndex = 1;
                    while ((pageKey = getPrevLink(pageKey)) !== null)
                        pageIndex++;
                    return pageIndex;
                };

                var model;

                var update = function () {
                    var page = pages[currentPageKey];
                    if (page) {
                        if (page.length >= pageSize + 1) {
                            model.items = page.slice(0, page.length - 1);
                        } else {
                            model.items = page.slice(0, pageSize);
                        }
                    } else {
                        model.items = []; //loading...
                    }
                    model.isLast = getNextLink(page) === null;
                    model.isFirst = currentPageKey === "";
                    model.pageIndex = getPageIndex(currentPageKey);
                };

                var setPageKey = function (newPageKey) {
                    if (newPageKey === null)
                        return;
                    currentPageKey = newPageKey;
                    update();

                    var fetchOptions = {};
                    for (var name in options) {
                        fetchOptions[name] = options[name];
                    }
                    fetchOptions.from = newPageKey;
                    fetchOptions.take = pageSize + 1; //+1 for the next-link
                    if (useSkip) {
                        fetchOptions.skip = (model.pageIndex - 1) * pageSize;
                        delete fetchOptions.from;
                    }
                    var tempPage = fetch(fetchOptions, function () {
                        pages[newPageKey] = tempPage;
                        update();
                    });
                };

                model = {
                    items: [],
                    first: function () {
                        setPageKey("");
                    },
                    next: function () {
                        setPageKey(getNextLink(pages[currentPageKey]));
                    },
                    prev: function () {
                        setPageKey(getPrevLink(currentPageKey));
                    }
                };

                model.first();

                return model;
            };

            $rootScope.clientPaginator = function (allModels, pageSize, filterFunction, getIdFunction=null) {
                var model;
                var searchInput;
                var getId = getIdFunction ?? ((obj)=>{return obj.Id;});

                var getFirstElementIdOrDefault = () => getFilteredModels(searchInput).length > 0 ? getId(getFilteredModels(searchInput)[0]) : "";                

                var currentPageKey = getFirstElementIdOrDefault();

                function getFilteredModels(searchInput) {
                    return filterFunction
                        ? filterFunction(allModels, searchInput)
                        : allModels;
                }

                var getNextLink = function () {
                    var startIndex = getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
                    var pageItems =  getFilteredModels(searchInput).slice(startIndex);

                    if (pageItems.length > pageSize) {
                        var nexPageFirstElement = getFilteredModels(searchInput)[startIndex + pageSize];
                        if (nexPageFirstElement)
                            return getId(nexPageFirstElement);
                    }

                    return null;
                };

                var getPrevLink = function () {
                    var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
                    if(startIndex > pageSize) {
                        return getId(getFilteredModels(searchInput)[startIndex - pageSize]);
                    }
                    else {
                        return getId(getFilteredModels(searchInput)[0]);
                    }
                };

                var getCurrentPageIndex = function () {
                    var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === currentPageKey);
                    if(startIndex === -1){
                        return 1;
                    }

                    var pageIndex = Math.floor(startIndex / pageSize ) + 1;
                    return pageIndex;
                };

                var update = function (pageKey) {

                    var startIndex =  getFilteredModels(searchInput).findIndex(x => getId(x) === pageKey);
                    var currentPageElements =  getFilteredModels(searchInput).slice(startIndex, startIndex + pageSize);

                    model.items = currentPageElements;

                    model.isLast = getNextLink() === null;
                    model.isFirst = currentPageKey === getFirstElementIdOrDefault();
                    model.pageIndex = getCurrentPageIndex();
                    model.isDataAvailable = currentPageElements.length>0 || !model.isFirst;
                };

                var setPageKey = function (newPageKey) {
                    if (newPageKey != null) {
                        currentPageKey = newPageKey;
                        update(newPageKey);
                    }
                };

                var setFilter = function(input){                    
                    searchInput = input;
                    setPageKey(getFirstElementIdOrDefault());
                };
                
                model = {
                    items: [],
                    first: function () {
                        var key = getFirstElementIdOrDefault();
                        setPageKey(key);
                    },
                    next: function () {
                        setPageKey(getNextLink());
                    },
                    prev: function () {
                        setPageKey(getPrevLink());
                    },
                    filter: function(input){
                        setFilter(input);
                    },                    
                };

                model.first();

                return model;
            };

            $rootScope.converFromUtc = function (dt) {
                if (dt) {
                    return moment(dt).utc().format();
                }
                return null;
            };

            $rootScope.features = Features.features;

            function getRoles() {
                if ($rootScope.permissions && $rootScope.permissions.Roles) {
                    return $rootScope.permissions.Roles;
                }
                return [];
            }

            $rootScope.adminOrInRole = function (roles) {
                var userRoles = getRoles();

                if (userRoles && (userRoles.indexOf("Admin") !== -1 || userRoles.indexOf("Developer") !== -1))
                    return true;

                if (roles) {
                    for (var i = 0; i < roles.length; i++) {
                        if (userRoles.indexOf(roles[i]) !== -1)
                            return true;
                    }
                }
                return false;
            };

            $rootScope.hasRole = function (role) {
                var userRoles = getRoles();
                return userRoles.indexOf(role) !== -1;
            }

            $rootScope.isDeveloper = function() { return $rootScope.hasRole('Developer'); };

            $rootScope.rootNode = function () {
                return $rootScope.chosenEntity && $rootScope.chosenEntity.IsRoot;
            };

            $rootScope.defaultLocation = function () {
                if ($rootScope.adminOrInRole(["Operations", "ReadOnlyOperations", "Reports"])) {
                    return "/dashboard";
                }

                if ($rootScope.adminOrInRole(["Products", "Finance"])) {
                    return "/products";
                }

                if ($rootScope.adminOrInRole(["Templates"])) {
                    return "/settings/invoices";
                }

                return "/user-settings/user";
            };

            $rootScope.downloadFile = function (url) {
                var a = document.createElement('a');
                a.href = url;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            $rootScope.publicSettings = PublicSettings;

            $rootScope.isBillwerkClient = LegalEntity.isBillwerkClient;

            $rootScope.enumToArray = function (obj, shouldTranslate) {
            var array = new Array();
                for (var key in obj) {
                    var value = obj[key];
                    if (shouldTranslate) {
                        value = gettextCatalog.getString(gettext(value));
                    }
                    array.push({
                        key: key,
                        value: value
                    });
                }
                return array;
            };

            $rootScope.$on('$routeChangeStart', function (angularEvent, next, current) {
                    window.scrollTo(0, 0);
                    if ($rootScope.embeddedContractId && next.$$route.embeddedNavigationAllowed === false) {
                        angularEvent.preventDefault();
                        $location.path('/embedded/contracts/' + $rootScope.embeddedContractId);
                    }
                });

            $rootScope.translateAndReplaceParameters = function (obj) {
                let text = obj.Text;
                text = gettextCatalog.getString(text);
                for (let key in obj.Parameters) {
                    text = text.replace("{" + key + "}", obj.Parameters[key]);
                }
                return text;
            }

            $rootScope.setEssentialHeadersOnUploader = function (obj) {
                angular.extend(obj.headers, { "Authorization": "Bearer " + $rootScope.accessToken });
                angular.extend(obj.headers, { "X-SELECTED-LEGAL-ENTITY-ID": $rootScope.chosenEntity.Id });
            }

            UserActivityTracker.Start();
            $rootScope.recordActivity = function (requestConfig) {
                UserActivityTracker.RecordActivity(requestConfig);
            };
        }
    ]);

itero.constant("TimeGranularity",
    {
        Precise: "Precise",
        Day: "Day"
    });

itero.constant("PostingStatus",
    {
        Draft: "Draft",
        Exported: "Exported",
        Deleted: "Deleted",
        Reversed: "Reversed"
    });

itero.constant("PdfDocumentFormat",
    {
        NoEInvoiceAttachment: "NoEInvoiceAttachment",
        ZugFerd1Comfort: "ZugFerd1Comfort",
        ZugFerd2Comfort: "ZugFerd2Comfort",
        ZugFerd2XRechnung: "ZugFerd2XRechnung"
    });

itero.constant("NormalizedInvoiceReferenceType",
    {
        Off: "Off",
        FinnishReferenceNumber: "FinnishReferenceNumber",
    });
